export const costs = [
  'Noches en vela buscando cómo traducir conceptos de energía nuclear complejos a un lenguaje que tus alumnos puedan entender.',
  'Clases improvisadas porque no encontraste un material claro y listo para usar a tiempo.',
  'Alumnos desconectados que sienten que la energía nuclear no tiene nada que ver con ellos ni con su realidad cotidiana.',
  'Silencios incómodos cuando un alumno pregunta qué es la radiactividad o por qué es importante la protección radiológica y no tienes una respuesta clara a mano.',
  'Fines de semana perdidos armando planificaciones, proyectos nucleares y evaluaciones desde cero una y otra vez.',
  'Incertidumbre sobre cómo enseñar fundamentos nucleares, seguridad, aplicaciones o gestión de residuos sin los recursos adecuados.',
];
